import { useLocation, useNavigate } from "react-router-dom";
import { URLdecode, URLencode } from "../utils/url";

export default function useGeneralActions() {
  const location = useLocation();
  const navigate = useNavigate();

  const resetPagination = () => {
    const params = URLdecode();
    if (Number(params?.page) === 1 && Number(params?.limit) === 10) {
      return;
    }
    navigate(
      `${location?.pathname}?${URLencode({
        ...params,
        page: 1,
        limit: 10,
      })}`,
      { replace: true }
    );
  };

  return {
    resetPagination,
  };
}
